/**
 * Send information about which filter a user clicked to a tracking service.
 */
// HACK: This is a quick-and-drity way to give us a little more insight into
// whether users interact with the filters. It's probably better to use
// something like https://github.com/react-ga/react-ga to wire this up.
function trackFilterClick(filterClicked) {
  if (!window.ga) {
    return;
  }

  // Send a custom event to Google Analytics.
  // See https://developers.google.com/analytics/devguides/collection/analyticsjs/events
  window.ga(
    'send',
    'event',
    'Filters',
    'change',
    filterClicked,
  );
}


/**
 * Get initial state values from upstream data.
 */
function getInitialState(data) {
  return {
    shootingsById: data.shootingsById,
    shootingIds: data.shootingIds,
    filteredShootingIds: data.shootingIds,
    copy: data.copy,
    filterOptions: data.filterOptions,
  };
}


export default function reducer(state, action) {
  switch (action.type) {
    case 'setdata':
      return {
        ...state,
        ...getInitialState(action.data),
      };

    case 'updatefilters':
      trackFilterClick(action.filterClicked);
      return {
        ...state,
        filteredShootingIds: state.shootingIds.filter((id) => {
          const filterMap = {
            // eslint-disable-next-line no-unused-vars
            escalated: (k, v) => 'TASER_ESCALATE',
            // eslint-disable-next-line no-unused-vars
            narrative: (k, v) => 'id',
            // eslint-disable-next-line no-unused-vars
            model: (k, v) => (`taser${v}`),
          };
          const transforms = {
            escalated: x => (x === true ? true : ''),
            narrative: x => parseInt(x, 10),
            model: x => (x === '' ? '' : true),
          };
          const shooting = state.shootingsById[id];

          return Object.keys(action.filters).every((k) => {
            const prop = filterMap[k] ? filterMap[k](k, action.filters[k]) : k;
            const val = transforms[k] ? transforms[k](action.filters[k]) : action.filters[k];

            if (val === '') {
              return true;
            }

            if (shooting[prop] !== val) {
              return false;
            }

            return true;
          });
        }),
      };

    default:
      throw new Error();
  }
}
